(function ($) {
    var storageKey = "bfs-sr:" + window.location.pathname + window.location.search;
    var resultSelector = "[data-search-result-id]";

    $("[data-search-return-link]").on("click", function (event) {
        if (event.which !== 1 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || $(this).attr("target") === "_blank") {
            return;
        }

        sessionStorage.setItem(storageKey, $(this).closest(resultSelector).attr("data-search-result-id"));
    });

    $(window).on("pageshow", function () {
        var resultId = sessionStorage.getItem(storageKey);

        if (!resultId) {
            return;
        }

        sessionStorage.removeItem(storageKey);

        var $result = $(resultSelector).filter(function () {
            return $(this).attr("data-search-result-id") === resultId;
        }).first();

        if ($result.length) {
            $("html, body").scrollTop(Math.max($result.offset().top - 16, 0));
        }
        else {
            $("html, body").scrollTop(0);
        }
    });
})(jQuery);